import React from 'react'
import data from './data.json'
import {
  Intro,
  Layout,
  Header,
  SectionTitle,
  Grid,
  GridItem,
} from '../../../../components'

import { Link } from 'gatsby'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        //state="design" disabling switcher
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Writing clearly and concisely helps users complete their tasks more
            efficiently. Clear writing is sharp, consistent and easy to
            comprehend. Concise writing eliminates unnecessary details, verbose
            language and excessive punctuation.
          </p>
        </Intro>

        <SectionTitle>Basic Guidelines</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Choose short, familiar words.</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              To quote Oscar Wilde, “Don’t use big words. They mean so little.”
              Especially when space is limited, try to keep copy tight by
              eliminating unnecessarily long words.
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 1</div>
                  <p class="u-type--medium">
                    Define unfamiliar words. If the definition gets lengthy,
                    re-evaluate your word choice.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 2</div>
                  <p class="u-type--medium">
                    Be consistent. The more predictable and familiar our content
                    is, the better.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Write in active voice.</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Using the active voice keeps content direct and
              objective-oriented.
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">Your account is open.</p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">Your account has been opened.</p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal l-margin-bottom--medium">
              Write in short, scannable sentences.
            </h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">Here's what you'll need:</p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    Here's what you will need to open your account:
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal l-margin-bottom--medium">
              Focus on a limited number of concepts or tasks at a time.
            </h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    Please verify your identity by answering the questions
                    below.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    Please verify your identity by answering the questions
                    below, then continue onto the account selection page to
                    choose your account type.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal l-margin-bottom--medium">
              Trim unnecessary copy.
            </h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">Continue</p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">Would you like to continue?</p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Allow readers to pace themselves.</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Where possible, write in bulltes or one sentence paragraphs.
              People tend to scroll right past big blocks of text.
            </p>
          </GridItem>
        </Grid>
        <hr />
        <SectionTitle>Conversational Writing</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Prepositions</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Break the “never end a sentence in a preposition” rule if
              necessary. It saves space, sounds more human, and doesn’t detract
              from clarity.
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    What account type are you interested in?
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    In which account type are you interested?
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Contractions</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Use contractions to convey a more approachable tone and use less
              space. Just make sure they don't create confusion.
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">Here’s what you’ll need.</p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">Here is what you will need.</p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Technical Terms and Jargon</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Jargon is any “special word or expression that is used by a
              particular profession or group and are difficult for others to
              understand.” It can create confusion (and more work) for people
              outside of the specialty group. The banking and financial services
              industry is rife with opportunities to include jargon-heavy
              content, but good UX requires ease of use. Simplify instances of
              jargon or technical terms wherever possible.
            </p>
            <p>
              The exception is in instances of necessary language stipulated by
              legal, compliance or other bank policy-generating parties. In
              these instances the information is, where possible, presented in a
              visually discreet fashion that indicates the content has a level
              of import that is to be reviewed and/or preserved for a users’
              records.
            </p>
          </GridItem>
        </Grid>

        <SectionTitle>Addressing Users</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">"We" and "You"</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Refer to clients and M{'&'}T with personal pronouns such as “you”
              and “we." This also goes for messaging related to the bank,
              internal systems, and how they may be affecting customer tasks.
              Certain input components (such as{' '}
              <Link className="link" to="/mt/components/checkbox/design/">
                checkbox
              </Link>
              ) can also be written in first person from the user's perspective
              where appropriate.
            </p>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 className="c-title-3--normal">
              When referring to customers and clients:
            </h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    What you'll need to open this account:
                  </p>
                  <p class="u-type--medium">
                    I want to receive mail for this account at a different
                    address.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    Here are the document requirements to open this account:
                  </p>
                  <p class="u-type--medium">
                    Check this box if you want to receive mail for this account
                    at a different address.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 className="c-title-3--normal">
              When referring to M{'&'}T and the bank's internal systems:
            </h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    We’re sorry for the inconvenience, but we’re experiencing an
                    issue with our system.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    The HOGAN system is experiencing an issue presently which is
                    causing an inconvenience.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Applicants vs. Customers</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Users are applicants before they become customers. After users
              become customers, we address them by name or with second-person
              pronouns.
            </p>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Title Usage in Account Opening</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              In certain account opening scenarios, it's necessary to refer to
              users with more specific titles than just "applicant."
            </p>
            <ul class="c-unordered-list">
              <li class="c-unordered-list__item">
                In joint account opening scenarios, always refer to users as
                “first” and “second” applicants, never “primary” or “secondary."
                This communicates the order of the application, not a user
                hierarchy.
              </li>
              <li class="c-unordered-list__item">
                In Credit Card account opening scenarios, the “primary account
                holder” is the person responsible for the account, and the
                “authorized user” can access the account. In contrast to a joint
                account scenario, these users do not hold the same account
                responsibilities. Always refer to these users as “primary
                account holder” and “authorized user."
              </li>
            </ul>
          </GridItem>
        </Grid>
        <SectionTitle>Capitalization</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Sentence Case</h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 1</div>
                  <p>
                    Capitalize the first word and any proper nouns in the
                    sentence.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 2</div>
                  <p>Include end punctuation unless otherwise noted.</p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Title Case</h2>
          </GridItem>
          <GridItem columns="9">
            <Grid>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 1</div>
                  <p>
                    Capitalize all words, except articles, prepositions,
                    conjunctions and two-letter verbs.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 2</div>
                  <p>
                    Capitalize prepositions that are five or more letters
                    (beyond, against, between...).
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="example">
                  <div class="example__title">Example 3</div>
                  <p>Do not include end punctuation unless otherwise noted.</p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <SectionTitle>Font Styles</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Bolding and Italics</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Instead of using bolding or italics to create emphasis, leverage
              UI elements like buttons, bullets or iconography to drive users to
              key messages and actions. Some components are designed with a
              heavier text weight by default for distinctive visual impact.
              Generally, any bolding or italics will be applied to a full
              component/block of text, rather than to select words.
            </p>
          </GridItem>

          <GridItem columns="3">
            <h2 class="c-title-3--normal">Underline</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Save underlining for hyperlinks and tool tips to help those
              components stand out in body copy. Never underline text in
              combination with italics, bolding or quotation marks.
            </p>
          </GridItem>
        </Grid>
        <SectionTitle>Punctuation</SectionTitle>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Ampersands</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Use ampersands ({'&'}) only in an official company, product or
              department name, otherwise spell out the word “and."
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    Create a pin for your new debit card and order your first
                    checks.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    Create a pin for your new debit card {'&'} order your first
                    checks.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Oxford Commas</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Do not use an Oxford Comma before “and” and/or “or". The exception
              to this rule is when a sentence includes a series of phrases or
              clauses.
            </p>
            <Grid>
              <GridItem columns="6">
                <div class="do">
                  <div class="do__title">
                    <i class="icon icon--success"></i> Do
                  </div>
                  <p class="u-type--medium">
                    Money laundering and financial crime remain serious threats
                    to individuals, businesses and our economy.
                  </p>
                </div>
              </GridItem>
              <GridItem columns="6">
                <div class="dont">
                  <div class="dont__title">
                    <i class="icon icon--error"></i> Don't
                  </div>

                  <p class="u-type--medium">
                    Money laundering and financial crime remain serious threats
                    to individuals, businesses, and our economy.
                  </p>
                </div>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
        <Grid>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Exclamation Points</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Save these for situations that are genuinely exciting and
              celebratory. Never use them in buttons or error messages, and try
              to avoid putting them at the end of user greetings. If you must
              use an exclamation point, limit to just one in a single layout.
            </p>
          </GridItem>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Periods</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Follow component microcopy guidelines to determine whether text
              should end in a period. Period usage in body copy adheres to the
              AP Guidelines standard. Never double space after a period – that
              is so 1963.
            </p>
          </GridItem>
          <GridItem columns="3">
            <h2 class="c-title-3--normal">Question Marks</h2>
          </GridItem>
          <GridItem columns="9">
            <p className="l-margin-top--none">
              Always include question marks after questions, even if a component
              typically doesn't use end punctuation.{' '}
            </p>
          </GridItem>
        </Grid>
      </Layout>
    </>
  )
}
